export interface InsidePage {
  src: string
  alt: string
}

/** The five real interior pages of the product — do not replace with mockups. */
export const insidePages: InsidePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/ovohdXSRtYG8bCbJBFAh2V/Captura_de_pantalla_2026-09-23_a_la(s)_8.43.30_p._m..png',
    alt: 'Interior page: Complete air intake path — follow the air from atmosphere to cylinder',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/sCvz5rJ66TobSSJrLaWKnE/Captura_de_pantalla_2026-09-23_a_la(s)_8.43.58_p._m..png',
    alt: 'Interior page: Vacuum leak map — common paths for unmetered air',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ohrSVPikwB4WCrWGGYhVH1/Captura_de_pantalla_2026-09-23_a_la(s)_8.43.43_p._m..png',
    alt: 'Interior page: Throttle body anatomy — understanding electronic throttle control',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/howD8wgWULZg58JTr9gXuy/Captura_de_pantalla_2026-09-23_a_la(s)_8.44.16_p._m..png',
    alt: 'Interior page: Engine coolant temperature — ECT, a small sensor with a large effect',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/wgvUndRLFiqCTcx3Tb6ke4/Captura_de_pantalla_2026-09-23_a_la(s)_8.44.37_p._m..png',
    alt: 'Interior page: Oxygen sensor system — exhaust feedback after combustion',
  },
]
